import { createFileRoute } from '@tanstack/react-router'
import PromotionManagement from '@/components/PromotionManagement'

export const Route = createFileRoute('/_authenticated/promotions/')({
  component: PromotionsManagement,
})

function PromotionsManagement() {
  return <PromotionManagement />
}
